import {useGlobalMaterials, MaterialType, GlobalMaterial} from '@domain/materials'

export const useGlobalMaterialsQuery = (materialType?: MaterialType) => {
  return useGlobalMaterials({
    options: {
      select: (data: GlobalMaterial[]): {id: string; label: string}[] =>
        data
          .filter(
            (globalMaterial) => materialType === undefined || globalMaterial.type === materialType
          )
          .map((globalMaterial) => ({label: globalMaterial.name, id: globalMaterial.id.toString()}))
    }
  })
}
